module.exports = __webpack_public_path__ + "static/media/Minoan_icon_200px.3b3acd82.png";